import { computed, ref } from "vue";
import ApiService from "@/services/api.service";
import {
  buildPortalAnalyticsChartsConfig,
  createEmptyPortalAccount,
  mapPortalAnalyticsSummaryToAccount,
} from "@/data/portal_analytics_mappers";

export function usePortalAnalytics() {
  const payload = ref(null);
  const loading = ref(false);

  async function loadPortalAnalytics() {
    loading.value = true;

    try {
      const res = await ApiService.get("portal/analytics");
      payload.value = res?.data?.data ?? res?.data ?? null;
    } catch (error) {
      console.warn("Failed to load portal analytics", error);
      payload.value = null;
    } finally {
      loading.value = false;
    }
  }

  const summary = computed(() => payload.value?.summary ?? null);

  const account = computed(() => {
    if (loading.value) {
      return createEmptyPortalAccount();
    }

    if (!summary.value) {
      return createEmptyPortalAccount();
    }

    return mapPortalAnalyticsSummaryToAccount(summary.value);
  });

  const analyticsCharts = computed(() =>
    buildPortalAnalyticsChartsConfig(payload.value),
  );

  return {
    payload,
    loading,
    summary,
    account,
    analyticsCharts,
    loadPortalAnalytics,
  };
}
